<ion-app>
    <div class="force-upgrade" *ngIf="forceUpgrade.blocking">
        <div class="force-upgrade__card">
            <h1 class="force-upgrade__title">Update required</h1>
            <p class="force-upgrade__body">This version of Vesta is no longer supported. Please update the app to continue.</p>
            <button type="button" class="force-upgrade__button" (click)="forceUpgrade.openStore()">Update</button>
        </div>
    </div>
    <app-property-sidemenu *ngIf="auth.currentUser && orgService.organization"></app-property-sidemenu>
    <app-landing-sidemenu *ngIf="!auth.currentUser"></app-landing-sidemenu>
    <ion-router-outlet [animated]="useAnimatedNavigation()" id="root-component"></ion-router-outlet>
    <app-dashboard-sidemenu *ngIf="auth.currentUser && orgService.organization"></app-dashboard-sidemenu>
    <app-chat-sidemenu *ngIf="!auth.currentUser && orgService.organization"></app-chat-sidemenu>
</ion-app>

